var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brief-container"},[_c('div',{staticClass:"brief-title title_font_40"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"brief-content med_font_18"},_vm._l((_vm.content),function(item,index){return _c('p',{key:index},[_vm._v(_vm._s(item))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fa56989","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/briefBox.vue
// module id = null
// module chunks = 